<template>
    <b-spinner v-if="!spark"></b-spinner>
    <div v-else>
        <b-card>
            <b-row>
                <b-col cols="12" md="6">
                    <b-card>
                        <b-form-group
                            :label="$t('name')"
                        >
                            <protokol-invalid-feedback :errors="validator.fieldErrors('name')">
                                <b-input v-model="name" />
                            </protokol-invalid-feedback>
                        </b-form-group>

                        <b-form-group
                            :label="$t('runtime')"
                        >
                            <v-select :options="runtimes" v-model="spark.lang" />
                        </b-form-group>
                    </b-card>
                </b-col>
                <b-col cols="12" md="6">
                    <b-row>
                        <b-col cols="12" v-if="handlerExpression">
                            <CodeEditor v-model="handlerExpression" :withButton="false" :controls="false"/>
                        </b-col>
                        <b-col cols="12"  v-if="packageExpression">
                            <CodeEditor v-model="packageExpression" :withButton="false" :controls="false"/>
                        </b-col>
                        <b-col cols="12" v-if="handlerExpression && packageExpression"> <b-button @click="save" variant="success" block>{{ $t('save') }}</b-button> </b-col>
                    </b-row>
                    
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>
<script>
import CodeEditor from '@/components/form/Editor/Code'
import { get } from 'lodash'
import vSelect from 'vue-select'

export default {
    name: 'Spark',
    components: {
        CodeEditor,
        vSelect,
    },
    data: function() {
        return {
            validator: this.$validator(),
            runtimes: ["node18","node17","node16","node14"],
            spark: {
                name: "",
                lang: null,
                settings: [
                    {
                        version: "0.1.0",
                        dist: {
                            handler: `'use strict'

module.exports = async (event, context) => {
  const result = {
    'body': JSON.stringify(event.body),
    'content-type': event.headers["content-type"]
  }

  return context
    .status(200)
    .succeed(result)
}
`,
                            package: `{
  "name": "spark-function",
  "version": "1.0.0",
  "description": "Spark Function",
  "main": "handler.js",
  "scripts": {
    "test": "echo \\"Error: no test specified\\" && exit 0"
  },
  "keywords": [],
  "author": "protokol.io",
  "license": "MIT"
}
`
                        }
                    }
                ]
            },
            ideVersion: "0.1.0",
        }
    },

    watch: {
        spark: {
            handler: function() {
                this.validator.revalidate()
            },

            deep: true
        },
    },

    computed: {
        name: {
            get() {
                return this.spark.name.toLowerCase()
            },

            set(val) {
                this.spark.name = val.toLowerCase()
            }
        },

        handlerExpression: {
            get() {
                let settings = this.spark.settings.find(s => {
                    return s.version == this.ideVersion
                })

                return get(settings, 'dist.handler', null)
            },

            set(val) {
                let settings = this.spark.settings.find(s => {
                    return s.version == this.ideVersion
                })

                settings.dist.handler = val
            }
        },

        packageExpression: {
            get() {
                let settings = this.spark.settings.find(s => {
                    return s.version == this.ideVersion
                })

                return get(settings, 'dist.package', null)
            },

            set(val) {
                let settings = this.spark.settings.find(s => {
                    return s.version == this.ideVersion
                })

                settings.dist.package = val
            }
        }
    },
    methods: {
        save() {
            if (!this.validator.pass()) return

            let popup = this.$loadingPopup()
            this.$sandbox.spark().create(this.spark).then((resp) => {
                this.$router.push(`/admin/spark/${resp.data.uuid}`)
            }).catch(err => {
                if (err.response) {
                    if (err.response.status == 409) {
                        this.$bvToast.toast(this.$t('sparkLimitReached'), {
                            title: this.$t('error'),
                            variant: 'danger'
                        })

                        return
                    }
                }

                this.$bvToast.toast(this.$t('unexpectedError'), {
                    title: this.$t('error'),
                    variant: 'danger'
                })
            }).finally(() => {
                popup.hide()
            })
        }
    },

    created() {
        this.validator.validate(this.spark, {
            isValidDNSName: (model, errors) => {
                if (!model.name.match(/^(?:\*\.)?[a-z0-9]+(?:[\-.][a-z0-9]+)*$/)) {
                    errors.add('name', [this.$t('notValid')])
                }
            },
        })
    }
}
</script>
